import { render, staticRenderFns } from "./customDoctor.vue?vue&type=template&id=145f16a8&scoped=true&"
import script from "./customDoctor.vue?vue&type=script&lang=js&"
export * from "./customDoctor.vue?vue&type=script&lang=js&"
import style0 from "./customDoctor.vue?vue&type=style&index=0&id=145f16a8&lang=scss&scoped=true&"
import style1 from "./customDoctor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f16a8",
  null
  
)

export default component.exports